import { render, staticRenderFns } from "./CardQuickLinks.vue?vue&type=template&id=4ab8550a"
import script from "./CardQuickLinks.vue?vue&type=script&lang=js"
export * from "./CardQuickLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports